(function () {
  function optionSelects(container) {
    return Array.from(container.querySelectorAll('select.custom-select_select'))
      .filter(function (s) { return s.name && s.name !== 'id'; });
  }

  // Reaffiche le bon libelle dans chaque custom-select (cas multi-options)
  function refreshLabels(container) {
    container.querySelectorAll('.custom-select').forEach(function (wrapper) {
      var sel = wrapper.querySelector('select.custom-select_select');
      if (!sel || !sel.name || sel.name === 'id') return;

      var spans = wrapper.querySelectorAll('.custom-select_label .main-span');
      if (!spans.length) return;

      spans.forEach(function (span) {
        var match = span.textContent.trim() === sel.value.trim();
        span.classList.toggle('hidden', !match);
      });
    });
  }

  function readSelection(container) {
    var out = {};
    optionSelects(container).forEach(function (s) { out[s.name] = s.value; });
    container.querySelectorAll('input[type="radio"]:checked').forEach(function (r) {
      if (r.name) out[r.name] = r.value;
    });
    return out;
  }

  function applySelection(container, selection) {
    var changed = false;

    Object.keys(selection).forEach(function (name) {
      var value = selection[name];

      optionSelects(container).forEach(function (s) {
        if (s.name === name && s.value !== value) { s.value = value; changed = true; }
      });

      container.querySelectorAll('input[type="radio"]').forEach(function (r) {
        if (r.name === name && r.value === value && !r.checked) { r.checked = true; changed = true; }
      });
    });

    if (changed) container.dispatchEvent(new Event('change', { bubbles: false }));
    refreshLabels(container);
  }

  var locked = false;

  function init() {
    var zones = Array.from(document.querySelectorAll('variant-selects, variant-radios'));
    if (!zones.length) return;

    zones.forEach(function (zone) {
      refreshLabels(zone);

      zone.addEventListener('change', function () {
        setTimeout(function () { refreshLabels(zone); }, 0);

        if (locked) return;
        locked = true;

        var selection = readSelection(zone);
        zones.forEach(function (other) {
          if (other !== zone) applySelection(other, selection);
        });

        setTimeout(function () { locked = false; }, 0);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* --- Fait glisser le Swiper vers l'image de la variante selectionnee --- */
(function () {
  function findSwiper() {
    var el = document.querySelector('.swiper-product');
    return el && el.swiper ? el.swiper : null;
  }

  function slideToMedia(mediaId) {
    var swiper = findSwiper();
    if (!swiper || !mediaId) return;

    var slides = Array.from(document.querySelectorAll('.swiper-product .swiper-slide'));
    var index = slides.findIndex(function (s) {
      return s.getAttribute('data-media-id') === String(mediaId);
    });

    if (index > -1) swiper.slideTo(index, 400);
  }

  function currentVariantFrom(zone) {
    // Le thème stocke la variante courante sur l'element variant-selects / variant-radios
    return zone.currentVariant || null;
  }

  function hook() {
    var zones = Array.from(document.querySelectorAll('variant-selects, variant-radios'));
    if (!zones.length) return;

    zones.forEach(function (zone) {
      zone.addEventListener('change', function () {
        setTimeout(function () {
          var v = currentVariantFrom(zone);
          if (v && v.featured_media && v.featured_media.id) {
            slideToMedia(v.featured_media.id);
          }
        }, 50);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hook);
  } else {
    hook();
  }
})();